import GoogleAnalyticsDataAccess from "../data/GoogleAnalyticsDataAccess";
import AppStoreConnectDataAccess from "../data/AppStoreConnectDataAccess";
import FlurryDataAccess from "../data/FlurryDataAccess";
import Constants from "./Constants";
import TwitterDataAccess from "../data/TwitterDataAccess";

export default class AnalyticsTypes {

    public static getLabel(value:string): string {
        let labels = {};
        labels[AppStoreConnectDataAccess.APPDOWNLOADS] = "App Store";
        labels[AppStoreConnectDataAccess.APPDOWNLOADS_INSTALLS] = "Installs";
        labels[AppStoreConnectDataAccess.APPDOWNLOADS_SALES] = "Sales";

        labels[FlurryDataAccess.APPUSAGE] = "App Usage";
        labels[FlurryDataAccess.APPUSAGE_SESSIONS] = "Sessions";
        labels[FlurryDataAccess.APPUSAGE_ACTIVEDEVICES] = "Active Devices";
        labels[FlurryDataAccess.APPUSAGE_ACTIVEUSERS] = "Active Users";
        labels[FlurryDataAccess.APPUSAGE_NEWDEVICES] = "New Devices";
        labels[FlurryDataAccess.APPUSAGE_TIMESPENT] = "Time Spend";
        labels[FlurryDataAccess.APPUSAGE_AVGTIMEPERDEVICE] = "Avg Time Per Device";
        labels[FlurryDataAccess.APPUSAGE_AVGTIMEPERSESSION] = "Avg Time Per Session";
        labels[FlurryDataAccess.APPUSAGE_MEDIANTIMEPERSESSION] = "Median Time Per Session";

        labels[FlurryDataAccess.EVENTPARAMS] = "Event Params";

        labels[Constants.METRIC_COUNT] = "";

        labels[GoogleAnalyticsDataAccess.USERSESSIONS] = "Web";

        labels[GoogleAnalyticsDataAccess.TRAFFICSOURCES] = "Web";
        labels[GoogleAnalyticsDataAccess.TRAFFICSOURCES_SOURCE] = "Traffic Source";
        labels[GoogleAnalyticsDataAccess.TRAFFICSOURCES_MEDIUM] = "Traffic Medium";
        labels[GoogleAnalyticsDataAccess.TRAFFICSOURCES_VISITS] = "Traffic Visits";

        labels[GoogleAnalyticsDataAccess.PAGEVIEWS] = "Web";
        labels[GoogleAnalyticsDataAccess.PAGEVIEWS_PAGEPATH] = "Page Path";
        labels[GoogleAnalyticsDataAccess.PAGEVIEWS_PAGEVIEWS] = "Page Views";
        labels[GoogleAnalyticsDataAccess.PAGEVIEWS_AVGTIMEONPAGE] = "Avg Time on Page";
        labels[GoogleAnalyticsDataAccess.PAGEVIEWS_UNIQUEPAGEVIEWS] = "Unique Page Views";

        labels[TwitterDataAccess.TWITTER_LIKES] = "Likes";
        labels[TwitterDataAccess.TWITTER_RETWEET] = "Retweets";

        return labels[value] ?? value;
    }

    public static aggregationMethod(analyticType:string):string {
        return Constants.AGGREGATION_SUM;
    }

    public static applyFormat(graphSettings:GraphSettings, value:number):any {
        /*if (analyticType == PushDataAccess.PUSH) {
            return Math.round(value * 100).toString() + "%";
        }*/
        if (graphSettings.dataFormat == "time") {
            return this.convertTime(value);
        }
        console.log(graphSettings.dataFormat);
        return value;
    }

    public static convertTime(value:number) {
        //var sec_num = parseInt(value, 10); // don't forget the second param
        var sec_num = value;
        var hours:any   = Math.floor(sec_num / 3600);
        var minutes:any = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds:any = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        //return hours+':'+minutes+':'+seconds;
        return hours + " hrs " + minutes + " min";
    }
}